/**
 * 🔴 **THE IMPORT MAP IS DERIVED, NOT STORED** (D118, PNK-121).
 *
 * Where each module's bundle is: `/modules/<name>/<version>/spa.js`, the version from that module's
 * own `package.json`. This used to be eleven rows in `tenantImportMapEntries`, hand-edited by a
 * migration every time a module's version moved — 068, 069, 070, 072, 073, 075, 076 and 078 exist for
 * no other reason. Two of them (076, 078) were written in the week D118 was taken, which is what
 * made the tax visible: a stylesheet change in the kit cost a schema change in the database.
 *
 * Every one of those eleven stored URLs was byte-identical to what `tools/module-url.ts` computes.
 * The rows were a hand-maintained cache of a build-time fact, and the only thing a hand-maintained
 * cache can add is drift — a version bumped in `package.json` but not in a migration would have
 * pointed the whole fleet at a directory `tools/pinksy.sh build-web` never wrote.
 *
 * 🔴 **`__PINKSY_IMPORT_MAP__` IS INJECTED AT CONFIG TIME** by `pinksyImportMap()` in
 * `apps/shell/vite.config.ts`, which reads `modules/<name>/package.json` through that same
 * `readModuleIdentity` + `moduleUrl` pair. So the shell bundle carries the map the build produced,
 * the two cannot disagree, and a version bump is one edit again instead of two.
 *
 * The `typeof` guard is for a test importing this module outside a vite transform, where the define
 * has not been substituted. It answers an empty map rather than throwing a ReferenceError, because a
 * unit test of something else should not have to know how the shell is built.
 */
import type { ImportMapEntry, AppImportMap } from "@/app/types";

declare const __PINKSY_IMPORT_MAP__: ImportMapEntry[];

export function appImportMap(): AppImportMap {
  const injected = typeof __PINKSY_IMPORT_MAP__ === "undefined" ? [] : __PINKSY_IMPORT_MAP__;
  return { imports: injected };
}
